<template>
  <div class="scroll-hide">
  <div class="download">
    <img class="app-main" :src="url" alt="">
    <div class="app-footer">
      <div class="footer-content">
        
        <img v-if="brand == 'COTTI'" src="https://cdn-product-prod.cotticoffee.com/cotti_h5/images/arc.svg" alt="">
        <img v-else src="../../assets/arc.png" alt="">
        <div class="footer-main">
          <!-- <div class="footer-title">
            <img v-if="brand == 'COTTI'" src="https://cdn-product-prod.yummy.tech/cotti_h5/images/title2.png" alt="">
            <img v-else src="../../assets/download/logo-tc.png" class="img-tc" alt="">
          </div> -->
          <open-button type="default"></open-button>
        </div>
      </div>
    </div>
    <van-overlay :show="weixin" class-name="app-overlay">
      <div class="wrapper" @click.stop>
        <div class="app-arrow">
          <img src="https://cdn-product-prod.cotticoffee.com/cotti_h5/images/arrow.png" alt="">
        </div>
        <div class="app-desc">
          <div class="text">微信中无法直接下载，点击右上角“…” </div>
          <div class="text">选择在浏览器中打开</div>
        </div>
        <div class="app-guide">
          <img src="https://cdn-product-prod.cotticoffee.com/cotti_h5/images/guide.png" alt="">
        </div>
      </div>
    </van-overlay>
  </div>
  </div>
</template>

<script>
import openButton from '../../components/openButton'
import { isWeixin } from "@/utils";
import qs from 'qs'
import {getDownloadBanner} from "../../api"

export default {
  name: 'Download',
  components:{
    openButton
  },
  data(){
    return {
      show: true,
      url:"",
      weixin: false,
      brand: this.$config.env.VUE_APP_BRAND
    }
  },
  mounted(){
    getDownloadBanner({"code":this.brand == "COTTI" ? "cotti-app-download" : "teacat-app-download"}).then(res=>this.url=res.data[0].url)
    this.channelViewMonitor()
    console.log(this.brand, 'brand')
    this.weixin = isWeixin()
  },
  methods:{
    channelViewMonitor(){
      const utm_source = qs.parse(window.location.search, { ignoreQueryPrefix: true }).utm_source
      const code = this.$route.query.c || utm_source || ''
      console.log(code,'code')
      this.$sensors.track('channel_appDownloadPage_view', { code });
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-hide {
  width: 100%;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
  overflow-y: scroll;
  position: fixed;
  position: -ms-device-fixed;
  top: 0px; left: 0px; right: 0px; bottom: 0px;
}
.download{
  height: 100%;
  background: #EEEFF0;
  position: relative;
  overflow: hidden;
  .app-main{
    width: 100%;
  }
  .app-footer{
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    .footer-bg{
      width: 100%;
    }
    .footer-content{
      font-size: 0;
      img{
        width: 103%;
        position: relative;
        bottom: -6px;
        left: -4px;
      }
      .footer-title{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 30px 40px 60px 0;
        img{
          width: 542px;
        }
        .img-tc {
          width: 328px;
        }
      }
      .footer-main{
        position: relative;
        z-index: 1;
        min-height: 210px;
        padding-bottom: 56px;
        background: white;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      .app-open{
        .open-action{
          width: 562px;
          height: 96px;
          border-radius: 48px;
          background: white;
          border: 1px solid #FF6A39;
          font-size: 32px;
          font-weight: 500;
          color: #FF6A39;
          line-height: 94px;
          text-align: center;
        }
      }

    }
  }

  .app-overlay{
    width: 100%;
    .wrapper{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .app-arrow{
        width: 100%;
        display: flex;
        justify-content: flex-end;
        img{
          margin: 28px 36px 32px 0;
          height: 88px;
        }
      }
      .app-desc{
        margin-bottom: 64px;
        .text{
          text-align: center;
          width: 551px;
          font-size: 32px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 52px;
        }
      }
      .app-guide{
        margin-bottom: 88px;
        img{
          width: 686px;
        }
      }
    }
  }
}
</style>
